export default __webpack_public_path__ + "static/media/roles_icon.f8fc2d3a.svg";